import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyList,
  getScreenAccessMasterList,
} from "../../redux/actions/mastersAction";
import RolePermissionMasterContent from "../../components/Masters/RolePermissionMaster/RolePermissionMasterContent";

const RolePermissionMaster = () => {
  const dispatch = useDispatch();

  const userData = useSelector((state) => state?.user?.userData);

  useEffect(() => {
    // dispatch(
    //   getCompanyList({
    //     id: "d46dccf0-a594-497b-8e50-fffb06f31849",
    //   })
    // );
    dispatch(getScreenAccessMasterList());
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <RolePermissionMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default RolePermissionMaster;
